export function categoryToString(category) {
  return category && [...category.path].map(cpe => cpe.title).join('/');
}